var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("not found")]),_c('p',[_vm._v("0ops we couldn't find the page, go back "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }